<lib-sales-insights-card
  [cardTitle]="config?.title"
  [subtitle]="subtitle"
  [loading]="loading"
  [error]="error"
  [empty]="empty"
>
  @if (canExport) {
    <button cardActions type="button" class="btn btn-sm si-progress__export" [disabled]="exporting" (click)="exportExcel()">
      <i class="fa-solid fa-file-excel me-1"></i>{{ 'SALES_INSIGHTS_EXPORT_EXCEL' | translate }}
    </button>
  }
  @if (searchable) {
    <lib-sales-insights-list-search cardToolbar [value]="query" (valueChange)="search($event)"></lib-sales-insights-list-search>
  }
  <div class="table-responsive si-progress">
    <table class="table table-sm align-middle mb-0">
      <thead>
        <tr>
          <th scope="col">{{ nameHeader }}</th>
          <th scope="col" class="text-end">{{ valueHeaderKey | translate }}</th>
          <th scope="col" class="text-end">{{ 'SALES_INSIGHTS_COL_TARGET' | translate }}</th>
          <th scope="col" class="si-progress__bar-col"></th>
          <th scope="col" class="text-end">{{ 'SALES_INSIGHTS_COL_ATTAINMENT' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (item of rows; track item.row.key) {
          <tr>
            <td class="si-progress__name">
              <span class="text-truncate">{{ item.name }}</span>
              @if (item.code) {
                <span class="si-progress__key">{{ item.code }}</span>
              }
            </td>
            <td class="text-end si-progress__number">{{ formatAmount(item.value) }}</td>
            <td class="text-end si-progress__number si-progress__muted">{{ formatAmount(item.target) }}</td>
            <td class="si-progress__bar-col">
              <div class="si-progress__track" aria-hidden="true">
                <span class="si-progress__fill" [style.width.%]="item.bar.valuePercent" [style.background]="barColor"></span>
                @if (item.bar.targetPercent !== null) {
                  <span class="si-progress__tick" [style.left.%]="item.bar.targetPercent"></span>
                }
              </div>
            </td>
            <td class="text-end si-progress__number" [class.si-progress__reached]="item.bar.reached">
              {{ item.percentText }}
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="5" class="text-body-secondary">{{ 'SALES_INSIGHTS_LIST_NO_MATCHES' | translate }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</lib-sales-insights-card>
